export enum ContactProfileState {
    Read = 'contact_read',
    ReadWrite = 'contact_read_write',
}
